<template>
  <v-card>
    <v-toolbar card dense dark color="primary">
      <v-toolbar-title class="white--text">Tracking {{servicioCompleto.Codigo}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat icon color="white" slot="activator" @click="cerrar">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-layout align-center justify-center v-if="!loaded">
      <half-circle-spinner :animation-duration="1000" :size="30" color="#000" class="pt-1"/>
      <v-toolbar-title class="pt-3">{{$t('otros.cargando')}}</v-toolbar-title>
    </v-layout>

    <v-tabs color="white" grow>
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab>{{$t('tracking.datosGenerales')}}</v-tab>
      <v-tab>{{$t('tracking.remitente')}}</v-tab>
      <v-tab>{{$t('tracking.destinatario')}}</v-tab>
      <v-tabs-items>
        <v-tab-item>
          <v-card flat class="pt-2">
            <v-layout wrap>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.numSeguimiento')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.Codigo}}</v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.numArrastre')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.ReferenciaVia}}</v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.fechaExpedicion')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{formatDate(servicioCompleto.Fecha)}} - {{servicioCompleto.Hora}}</v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.tipoServicio')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.TipoServicio.name}}</v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.referencia')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.Referencia}}</v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.estadoExpedicion')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.Estado}}</v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.numBultos')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.NumBultos}}</v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.peso')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.PesoTotal}}</v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card flat class="pt-2">
            <v-layout wrap>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.nombre')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text
                  class="pt-0 pb-1"
                >{{servicioCompleto.Remitente.Nombre}} {{servicioCompleto.Remitente.Nombre2}}</v-card-text>
              </v-flex>

              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.nif')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.Remitente.Nif}}</v-card-text>
              </v-flex>

              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.email')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.Remitente.Email}}</v-card-text>
              </v-flex>

              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.telefono')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.Remitente.Telefono}} </v-card-text>
              </v-flex>

              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.pais')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.Remitente.Pais}}</v-card-text>
              </v-flex>

              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.poblacionCP')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text
                  class="pt-0 pb-1"
                >{{servicioCompleto.Remitente.Poblacion}} {{servicioCompleto.Remitente.CodigoPostal}}</v-card-text>
              </v-flex>

              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.direccion')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.Remitente.Direccion}}</v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card flat class="pt-2">
            <v-layout wrap>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.nombre')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text
                  class="pt-0 pb-1"
                >{{servicioCompleto.Destinatario.Nombre}} {{servicioCompleto.Destinatario.Nombre2}}</v-card-text>
              </v-flex>

              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.nif')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.Destinatario.Nif}}</v-card-text>
              </v-flex>

              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.email')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.Destinatario.Email}}</v-card-text>
              </v-flex>

              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.telefono')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.Destinatario.Telefono}}</v-card-text>
              </v-flex>

              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.pais')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.Destinatario.Pais}}</v-card-text>
              </v-flex>

              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.poblacion')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex sm3 xs6>
                <v-card-text
                  class="pt-0 pb-1"
                >{{servicioCompleto.Destinatario.Poblacion}} {{servicioCompleto.Destinatario.CodigoPostal}}</v-card-text>
              </v-flex>

              <v-flex sm3 xs6>
                <v-card-text class="pt-0 pb-1">
                  <b>{{$t('tracking.direccion')}}:</b>
                </v-card-text>
              </v-flex>
              <v-flex xs9>
                <v-card-text class="pt-0 pb-1">{{servicioCompleto.Destinatario.Direccion}}</v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>

    <v-card-text>
      <v-card-title class="pa-0 ma-0">
        <h4>{{$t('tracking.trazabilidad')}}</h4>
        <v-spacer/>
        <v-btn color="primary" small v-if="tracking.CodigoAgenciaDestinoVia === 1010" target="_blank" :href="'https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber='+servicioCompleto.ReferenciaVia">Ver seguimiento internacional</v-btn>
        <v-btn color="primary" small v-if="tracking.CodigoAgenciaDestinoVia === 1011" target="_blank" :href="'https://www.tnt.com/express/es_es/site/herramientas-envio/seguimiento.html?searchType=con&cons='+servicioCompleto.ReferenciaVia">Ver seguimiento internacional</v-btn>
      </v-card-title>
      <v-data-table :headers="headersTrazabilidad" :items="tracking.Trazabilidades" hide-actions>
        <template v-slot:items="props">
          <td
            class="text-xs-left"
          >{{ formatDateTime(props.item.FechaTracking) }}</td>
          <td class="text-xs-left">{{ props.item.Estado }}</td>
          <td class="text-xs-left">{{ props.item.Tipo }}</td>
          <td class="text-xs-left">
            <v-tooltip bottom v-if="props.item.Longitud!=='0'">
              <v-btn flat icon color="secondary" slot="activator" @click="showMap(props.item)">
                <v-icon>place</v-icon>
              </v-btn>
              <span>{{$t('servicios.acciones.map')}}</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
      <hr>
      <h4>{{$t('tracking.incidencias')}}</h4>
      <v-data-table :headers="headersIncidencias" :items="tracking.Incidencias" hide-actions>
        <template v-slot:items="props">
          <td
            class="text-xs-left"
          >{{ formatDateTime(props.item.FechaTracking) }}</td>
          <td class="text-xs-left">{{ props.item.Texto }}</td>
          <td class="text-xs-left">{{ props.item.Tipo }}</td>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions class="justify-center"></v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import { HalfCircleSpinner } from "epic-spinners";

export default {
  name: "ServiceTracking",
  components: {
    HalfCircleSpinner
  },
  data() {
    return {
      loaded: false,
      tracking: {
        Trazabilidades: [],
        Incidencias: []
      },

      headersTrazabilidad: [
        { sortable: false, text: "Fecha", value: "Fecha" },
        { sortable: false, text: "Estado", value: "Estado" },
        { sortable: false, text: "Tipo", value: "Tipo" },
        { sortable: false, text: "Mapa", value: "" }
      ],
      headersIncidencias: [
        { sortable: false, text: "Fecha", value: "Fecha" },
        { sortable: false, text: "Texto", value: "Texto" },
        { sortable: false, text: "Tipo", value: "Tipo" }
        //{ text: "Codigo", value: "Codigo" },
      ]
    };
  },
  methods: {
    formatDate(value) {
      if (!value) return "";

      const datePart = String(value).split("T")[0];
      if (datePart === "0001-01-01" || datePart === "2000-01-01") return "";

      return datePart;
    },
    formatDateTime(value) {
      if (!value) return "";

      const parts = String(value).split("T");
      return parts.length > 1 ? parts[0] + " " + parts[1] : parts[0];
    },
    normalizeTracking(value) {
      value = value || {};
      return Object.assign({}, value, {
        Trazabilidades: value.Trazabilidades || [],
        Incidencias: value.Incidencias || []
      });
    },
    cerrar() {
      this.$emit("cerrar");
    },
    showMap(item){
      let ruta = "https://www.google.com/maps?z=12&t=m&q=loc:"+item.Latitud+"+"+item.Longitud;
      //console.log("Mostrando mapa "+item.Latitud+" - "+item.Longitud + " - "+ruta);
      window.open(ruta, "_blank");    
    },
    ...mapActions("services", ["getTracking"])
  },
  props: {
    servicio: {
      type: Object,
      required: true
    }
  },
  computed: {
    servicioCompleto() {
      const servicio = this.servicio || {};
      return Object.assign({}, servicio, {
        Remitente: servicio.Remitente || {},
        Destinatario: servicio.Destinatario || {},
        TipoServicio: servicio.TipoServicio || {}
      });
    }
  },
  watch: {
    servicio: async function(newVal, oldVal) {
      this.loaded = false;
      this.tracking = this.normalizeTracking();
      if (!newVal || !newVal.Codigo) return;

      let res = await this.getTracking(newVal);
      if (res.estado) {
        this.loaded = true;
        this.tracking = this.normalizeTracking(res.respuesta);
      }
    }
  }
};
</script>
